import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Container, Grid, makeStyles, Typography } from "@material-ui/core";

import { PAGES } from "..";
import { api } from "../../services";
import { COLORS } from "../../theme/colors";
import { EXCEL_FILE_TYPE } from "../../constants";
import { UploadButton } from "../../components/base/UploadButton";
import { Button, TextButton } from "../../components/base/Button";
import { saveNotification } from "../../redux/notification/actions";
import blankFileImg from "../../assets/images/portfolio/blankFile.png";
import uploadExcelImg from "../../assets/images/portfolio/uploadExcel.png";
import downloadExcelImg from "../../assets/images/portfolio/downloadExcel.png";

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(10),
    fontWeight: 400,
  },
  subTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(5),
    fontWeight: 400,
  },
  card: {
    boxShadow: `0px 4px 10px ${COLORS.darks[0][6]}`,
    border: `1px solid ${COLORS.darks[0][10]}`,
    borderRadius: theme.spacing(1),
    width: 240,
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    padding: theme.spacing(4),
    "&:hover": {
      boxShadow: "0px 10px 10px rgba(193, 37, 173, 0.1)",
    },
    height: 290,
    position: "relative",
  },
  textBtn: {
    color: COLORS.purple,
    position: "absolute",
    bottom: theme.spacing(5.5),
  },
  onlineFormBtn: {
    position: "absolute",
    bottom: theme.spacing(4.5),
  },
  templates: {
    position: "absolute",
    bottom: theme.spacing(2.5),
  },
  img: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  template: {
    textDecoration: "none",
    margin: `0px ${theme.spacing(1)}px`,
  },
}));

export const uploadFile = (dispatch, event, onSuccess) => {
  const file = event.target.files[0];
  const form = new FormData();
  form.append("file", file);
  return api
    .post("/onboarding/settings/portfolio-registration/draft/upload/", form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data)
    .then((data) => onSuccess(data))
    .catch((err) => {
      const statusCode = err?.response?.status;
      let message;
      if (statusCode === 400) {
        if ("file" in err.response.data) {
          message = err.response.data["file"][0];
        } else if ("error" in err.response.data) {
          message = err.response.data["error"];
        }
      } else if (statusCode === 500) {
        message =
          "Error when processing the uploaded file. Make sure the uploaded file matched with template";
      } else {
        message = "Something went wrong. Please try again";
      }
      dispatch(saveNotification({ message, error: true }));
    });
};

export const Portfolio = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);

  const uploadXls = (event) => {
    setUploading(true);
    uploadFile(dispatch, event, (data) => {
      navigate(PAGES.gettingStarted.setup, { state: data });
    }).finally(() => {
      setUploading(false);
    });
  };

  return (
    <Container maxWidth="lg">
      <Typography className={classes.title} variant="h1" align="center">
        Great, let’s go!
      </Typography>
      <Typography className={classes.subTitle} variant="h2" align="center">
        How would you like to start the portfolio registration?
      </Typography>
      <Grid container justifyContent="center">
        <Grid className={classes.card} container direction="column" alignItems="center">
          <img className={classes.img} src={blankFileImg} alt="blank-file-icon" />
          <Button
            text="ONLINE FORM"
            rootStyle={classes.onlineFormBtn}
            onClick={() => navigate(PAGES.gettingStarted.setup)}
          />
        </Grid>

        <Grid className={classes.card} container direction="column" alignItems="center">
          <img className={classes.img} src={downloadExcelImg} alt="download-excel-icon" />

          <Typography className={classes.textBtn} align="center">
            DOWNLOAD TEMPLATE
          </Typography>
          <Grid className={classes.templates} container justifyContent="center">
            <a
              className={classes.template}
              href={`${process.env.REACT_APP_API_URL}/media/sample_portfolio.xlsx`}
              download
            >
              <TextButton text="XLS" />
            </a>
            <a
              className={classes.template}
              href={`${process.env.REACT_APP_API_URL}/media/sample_portfolio.csv`}
              download
            >
              <TextButton text="CSV" />
            </a>
          </Grid>
        </Grid>

        <Grid className={classes.card} container direction="column" alignItems="center">
          <img className={classes.img} src={uploadExcelImg} alt="download-excel-icon" />
          <UploadButton
            accept={EXCEL_FILE_TYPE}
            loading={uploading}
            onChange={uploadXls}
            text="UPLOAD XLS / CSV"
            onlyText
          />
        </Grid>
      </Grid>
    </Container>
  );
};
